<!-- Color Section -->
<div *ngIf="color_list.length && ![3].includes(current_activity_id)" class="col">
  <h4 class="mb-3 display-4">{{ 'color' | translate }}</h4>
  <hr class="mb-3" />
  <div class="row row-cols-7 row-cols-md-12 g-3">
    <div *ngFor="let device of color_list" class="col col-auto">
      <div
        as-button
        class="device-color"
        [class.device-color__active]="device.id === global.selected_color_device_id"
        [class.elevate]="device.id !== global.selected_color_device_id"
        [style.background-color]="device.color | lowercase"
        [attr.aria-label]="device.original_color || device.color"
        (click)="selectColorClick(device)"
      ></div>
    </div>
  </div>
  <h5 class="mt-3 mb-0" *ngIf="global.active_device as currentDevice">
    {{ currentDevice.original_color || currentDevice.color }}
  </h5>
</div>

<!-- Storage Capacity -->
<div *ngIf="storage_list.length && ![3].includes(current_activity_id)" class="col mt-2rem">
  <h4 class="mb-3 display-4">
    {{ 'storage_capacity' | translate }}
  </h4>
  <hr class="mb-3" />
  <div class="row row-cols-2 row-cols-md-4 g-3">
    <div *ngFor="let device of storage_list" class="col">
      <div
        as-button
        class="card overflow-auto h-100"
        [ngClass]="{ 'p-3': device.admin }"
        [class.active-card]="getActiveStorage(device)"
        [class.elevate]="
          device.size !== global.selected_storage_size ||
          device.id !== global.selected_storage_device_id
        "
        [attr.aria-label]="device.size"
        (click)="selectStorageClick(device)"
      >
        <div class="card-body flex-column d-flex align-items-center justify-content-center">
          <h5 class="mb-1">{{ device.size }}</h5>
          <small class="text-secondary fw-normal">
            {{ device.price?.onetime?.cost_to_currency }}
          </small>
          <span
            *ngIf="!!device.price?.monthly?.cost_to_currency"
            class="text-secondary text-size-sm fw-normal"
          >
            {{ 'plus' | translate }}
            {{ appendMonthlyLabel(device.price.monthly.cost_to_currency) }}
          </span>
        </div>

        <ng-container *ngTemplateOutlet="adminBadge; context: { admin: device.admin }" />
      </div>
    </div>
  </div>
</div>

<!-- Name Overrides -->
<div *ngIf="name_override_list.length > 0 && show_options" class="col mt-2rem">
  <h4 class="mb-3 display-4">
    {{ 'options' | translate }}
    <span class="text-secondary fs-6"> ({{ 'choose_one' | translate }}) </span>
  </h4>
  <hr class="mb-3" />
  <div class="row row-cols-1 g-3">
    <div *ngFor="let device of name_override_list" class="col">
      <div
        as-button
        class="card"
        [ngClass]="{ 'p-2': device.admin }"
        [class.active-card]="device.id === global.selected_name_override_id"
        [class.elevate]="device.id !== global.selected_name_override_id"
        [attr.aria-label]="device.name_override || device.name"
        (click)="selectNameOverrideClick(device)"
      >
        <div class="card-body">
          <h5 class="mb-1">{{ device.name_override || device.name }}</h5>
        </div>

        <ng-container *ngTemplateOutlet="adminBadge; context: { admin: device.admin }" />
      </div>
    </div>
  </div>
</div>

<ng-template #adminBadge let-admin="admin">
  <ts-admin-override-badge
    *ngIf="admin"
    class="position-absolute bottom-0 end-0 border-top-left-radius"
  />
</ng-template>
